import React from 'react';
import { cn } from './lib/utils';

/* Sticky bottom bar — port of `~co/common/footer`. */
export const Footer = React.forwardRef(function Footer(
  { as = 'div', className = '', ...etc },
  ref,
) {
  const Component = as;

  return (
    <Component
      ref={ref}
      className={cn('ui-footer', className)}
      {...etc}
    />
  );
});

export function FooterSpace() {
  return <div className='ui-footer-space' />;
}
